export default "__VITE_ASSET__DbUw6sd4__"